import Rollover from '../../components/course/rollover';
<template><Rollover @course={{@model}} @visit={{@controller.loadCourse}} /></template>
